var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuarantee = function SvgGuarantee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 27,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FF3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#guarantee_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.125v4.063l-2.5-1.22-2.5 1.22v-4.062m6.667-3.251c0 2.244-1.866 4.063-4.167 4.063s-4.167-1.82-4.167-4.063C7.833 8.631 9.7 6.813 12 6.813s4.167 1.818 4.167 4.062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.75 11.225.913.875 2.087-2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "guarantee_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 6h10v13H7z"
  })))));
};
export default SvgGuarantee;